import { Stack } from "@mui/material";
import { Suspense, useEffect, useRef, useState } from "react";
// eslint-disable-next-line import/named
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";

import { ErrorBanner } from "../components/ErrorBanner/ErrorBanner";
import { theContactManager, theCtiManager, theUCClient } from "../globals";
import { Dashboard } from "../pages/Dashboard";
import LoginOauth from "../pages/Login/LoginOAuth";
import { getState, useStore } from "../zustand/store";
import { LoginRouteWrapper } from "./LoginRouteWrapper";
import { ProtectedRoute } from "./ProtectedRoute";

const router = createBrowserRouter([
	{
		path: "/login",
		element: (
			<LoginRouteWrapper>
				<LoginOauth />
			</LoginRouteWrapper>
		)
	},
	{
		path: "/dashboard",
		element: (
			<ProtectedRoute>
				<Dashboard />
			</ProtectedRoute>
		)
	},
	{
		path: "/",
		element: (
			<ProtectedRoute>
				<Navigate replace to="/dashboard" />
			</ProtectedRoute>
		)
	}
]);

/**
 * Router
 * @returns Router
 */
export const Router = () => {
	const [loading, setLoading] = useState(true);
	const loggedIn = useStore((state) => state.loggedIn);
	const token = useStore((state) => state.token);
	const ucsid = useStore((state) => state.ucsid);
	const ucserveruri = useStore((state) => state.ucserveruri);
	const setMySelfIsLogged = useStore((state) => state.setMySelfIsLogged);

	const isConnected = useRef(false);

	useEffect(() => {
		if (isConnected.current) return;
		setLoading(true);

		if (token) {
			// If the token is set, and we wanted to stay logged in the previous login, try to use the token to login
			theUCClient
				.connectStandAlone({ UCSid: ucsid, UCSUri: ucserveruri, token })
				.then((result) => {
					if (typeof result === "number") {
						getState().setMySelfToken(undefined);
						getState().setMySelfIsLogged(false);
					} else {
						theCtiManager.init();
						theContactManager.init();
					}
				})
				.catch((result) => {
					if (typeof result === "number") {
						getState().setMySelfToken(undefined);
						getState().setMySelfIsLogged(false);
					}
				})
				.finally(() => {
					setLoading(false);
					isConnected.current = true;
				});
		} else {
			setLoading(false);
			setMySelfIsLogged(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loggedIn, token]);

	if (loading) return null;

	return (
		<Suspense fallback={<div />}>
			<Stack height="100%">
				<ErrorBanner spinner showCloseIcon />
				<RouterProvider router={router} />
			</Stack>
		</Suspense>
	);
};
